import {Box, Typography} from '@mui/material';
import {AppButton} from 'components/buttons';
import {BaseCard} from 'components/card';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import AppBaseCardHeader from 'components/card/AppBaseCardHeader';
import {AppConfirmationDialog, AppConfirmationDialogRefType} from 'components/dialogs';
import {AppMenu} from 'components/menus';
import {AppEllipsisTypography} from 'components/typographies';
import {format} from 'date-fns';
import {extractFirstElementText} from 'global';
import {useGetItemById} from 'hooks';
import {useReminderHelper} from 'hooks/reminders/useReminderApi';
import parser from 'html-react-parser';
import {Edit, Trash} from 'iconsax-react';
import {REMINDER_OBJECT_TYPE, ReminderModel} from 'models/reminder';
import React, {useEffect, useRef} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
interface ReminderCardProps {
    reminder: ReminderModel;
    handleUpdate?: () => void;
    handleDelete?: (id: string) => void;
}
export const ReminderCard: React.FC<ReminderCardProps> = ({reminder, handleDelete, handleUpdate}) => {
    const reminderConfirmationDialiogRef = useRef<AppConfirmationDialogRefType>(null);
    const reminderViewDialiogRef = useRef<AppConfirmationDialogRefType>(null);
    const {ticketNo} = useParams();
    const navigate = useNavigate();
    const {getItemById, getItemByIdResponse} = useGetItemById();

    useEffect(() => {
        if (reminder.objectId && reminder.objectType === REMINDER_OBJECT_TYPE.ITEM_DATA && !ticketNo) {
            getItemById({variables: {id: reminder.objectId}});
        }
    }, []);

    const {getReminderTypeName} = useReminderHelper();
    const handleTicketNavigation = () => {
        if (getItemByIdResponse?.url) {
            navigate(getItemByIdResponse.url);
        }
    };

    return (
        <>
            <BaseCard
                headerDateInSameLine
                headerData={
                    <AppBaseCardHeader
                        dateTime={reminder.reminderDate}
                        title={reminder.title}
                        chipProps={{
                            children: (
                                <>
                                    {getReminderTypeName(reminder.type)}
                                    {getItemByIdResponse?.ticketNo ? ` #${getItemByIdResponse.ticketNo}` : ''}
                                </>
                            ),
                            onClick: () => {
                                handleTicketNavigation();
                            },
                        }}
                    />
                }
                footerData={
                    reminder.description &&
                    reminder.description.length > 0 && (
                        <AppEllipsisTypography
                            hideDetails
                            variant="body2"
                            whiteSpace="normal"
                            text={extractFirstElementText(reminder.description ?? '')}
                            maxLetters={150}
                        />
                    )
                }
                menus={
                    <AppMenu
                        menuItems={[
                            ...(handleUpdate
                                ? [
                                      {
                                          label: 'Edit',
                                          icon: (
                                              <Box mt={1}>
                                                  <Edit color="blue" variant="Outline" size="16px" />
                                              </Box>
                                          ),
                                          onClick: () => handleUpdate(),
                                      },
                                  ]
                                : []),
                            ...(handleDelete
                                ? [
                                      {
                                          label: 'Remove',
                                          icon: (
                                              <Box mt={1}>
                                                  <Trash color="red" variant="Bold" size="16px" />
                                              </Box>
                                          ),
                                          onClick: () => reminderConfirmationDialiogRef.current?.handleOpen(),
                                      },
                                  ]
                                : []),
                        ]}
                    />
                }
            />
            {handleDelete && (
                <AppConfirmationDialog
                    renderElement={(_open, handleOpen) => <></>}
                    ref={reminderConfirmationDialiogRef}
                    icon={<Trash variant="Bold" />}
                    onConfirmClick={(_open, _handleOpen, handleClose) => {
                        handleDelete(reminder.id);
                    }}
                    title="Delete Reminder"
                    description="Are you sure you want to delete this reminder?"
                />
            )}
            <AppConfirmationDialog
                renderElement={(_open, handleOpen) => <></>}
                ref={reminderViewDialiogRef}
                alignContainer="left"
                title={reminder.title}
                description={reminder.description ? parser(reminder.description) : ''}
                footer={<></>}
            />
        </>
    );
};

export default ReminderCard;
